/**
 * @generated SignedSource<<19dbd62c735cbe354d75d87ea50d5a29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SongManageShareSharee_song$data = {
  readonly id: string;
  readonly permissions: ReadonlyArray<{
    readonly canEdit: boolean;
    readonly didAccept: boolean;
    readonly email: string;
    readonly isOwner: boolean;
    readonly user: string;
  }>;
  readonly viewerPermission: {
    readonly canEdit: boolean;
    readonly didAccept: boolean;
    readonly email: string;
    readonly isOwner: boolean;
    readonly user: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"SongRejectShare_song">;
  readonly " $fragmentType": "SongManageShareSharee_song";
};
export type SongManageShareSharee_song$key = {
  readonly " $data"?: SongManageShareSharee_song$data;
  readonly " $fragmentSpreads": FragmentRefs<"SongManageShareSharee_song">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "user",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOwner",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canEdit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "didAccept",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SongManageShareSharee_song",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SongRejectShare_song"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SongPermission",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SongPermission",
      "kind": "LinkedField",
      "name": "viewerPermission",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Song",
  "abstractKey": null
};
})();

(node as any).hash = "64b2d9af3e95732d3fce0d6b452cae68";

export default node;
